import { CdkMenu, CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import type { AfterViewInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Input,
  signal,
  ViewChild,
} from '@angular/core';
import type { Subject } from 'rxjs';
import { PalantirContentComponent } from '../../../../content/content.component';
import { PalantirIconComponent } from '../../../../icon/icon.component';
import { PalantirTextComponent } from '../../../../text/text.component';
import type { PalantirTableDropdownItem } from '../../../table.type';

@Component({
  selector: 'palantir-table-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    CdkMenuModule,
    PalantirIconComponent,
    PalantirContentComponent,
    PalantirTextComponent,
  ],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PalantirTableDropdownComponent implements AfterViewInit {
  @ViewChild(CdkMenu) public menu!: CdkMenu;

  @Input({ required: true }) public element!: PalantirTableDropdownItem;

  @Input({ required: true }) public blockScroll$!: Subject<boolean>;

  public readonly selectedOption = signal<number | string | null>(null);

  public readonly valueLabel = computed(this.computeValueLabel.bind(this));

  public readonly isMenuOpen = signal(false);

  private valueToLabel: Record<number | string, string> = {};

  public ngAfterViewInit(): void {
    this.selectedOption.set(this.element.value ?? null);

    for (const option of this.element.options) {
      if (option.value === null) {
        continue;
      }

      this.valueToLabel[option.value] = String(option.label);
    }
  }

  public selectOption(value: number | string | null): void {
    this.selectedOption.set(value);
    void this.element.action(value);
  }

  public computeValueLabel(): string {
    const value = this.selectedOption();
    if (value === null) {
      return this.element.label;
    }

    return Reflect.get(this.valueToLabel, value!) ?? '';
  }

  public onMenuOpenChange(isOpen: boolean): void {
    this.isMenuOpen.set(isOpen);
    this.blockScroll$.next(isOpen);
  }
}
